/* eslint-disable @typescript-eslint/no-explicit-any */
import { actionButtonNavigationConfigType } from './action-button-navigation-config.type';
import { PaymentProvider } from './cards.type';
import { DocumentActionType } from './common.enum';
import { ButtonActionType } from './common.type';
import {
  AlertStyleConfigurationType,
  GlobalThemeConfiguration,
  SectionNames,
  WidgetNames,
} from './config.type';
import { BorderRadiusClass } from './default-constants/global-styling.enum';
import { PACKS } from './default-constants/workflow-constants.type';
import { PageNavigationMap } from './page-id-mapping.types';
import {
  FormFieldConfig,
  UiZoneConfig,
  UiZoneDevicesConfig,
  UiZoneWidgetAttributeConfig,
} from './ui-system-config.v2.type';
import { FormsConfigType } from './workflow-widget-config.type';
import {
  NestedWorkflowWidgetConfiguration,
  WorkflowZoneConfig,
  WorkflowZoneDevicesConfig,
} from './workflow.v2.type';

export enum PAGELAYOUTTYPE {
  SECTION = 'section',
  WIDGET = 'widgetPage',
}

export enum Page {
  ACCOUNT_PAGE = 'account-page',
  PROFILE_PAGE = 'profile-page',

  QUICK_LINKS_WIDGET = 'quick_links_widget',
  RESEND_WIDGET = 'resend_links_widget',
  SWITCH_NAVIGATOR_QUICK_LINK = 'switch_navigator_quick_link',
  MULTI_ICON_QUICK_LINK_WIDGET = 'multi_icon_quick_link_widget',
  ACCOUNT_CREDENTIALS = 'account-credentials',
}

export type ComponentLabel = Page | WidgetNames | SectionNames;

export type WidgetFieldOptions = {
  position?: number;
  id?: string;
  field_type: string;
  field_name: string;
  label: string;
  type: string;
  show: boolean;
};
export type WidgetFields = {
  field_name: string;
  field_value?: string | number | boolean;
  label: string;
  subTitle?: string;
  type: string;
  show: boolean;
  options: WidgetFieldOptions[];
  section?: string;
  uniqueId?: number;
  timer?: number;
  placeholder?: string;
  showDetailsButton?: boolean;
  selected?: boolean;
};

export type WidgetConfiguration = {
  additionalfields: WidgetFields[];
};

export type RightWidgetConfiguration = {
  nestedWidgets: {
    [uniqueId: string]: NestedWorkflowWidgetConfiguration;
  };
  screenName: string;
  subtitle?: string;
  elementsConfig: WidgetFields[];
  isRemovable: boolean;
  isWidgetPage?: boolean;
  attributes?: any;
  page?: string;
  uniqueId: number | string;
  showMargin: boolean;
  showPadding: boolean;
  showTextColor?: boolean;
  showFontStyle?: boolean;
  showHorizontalAlign?: boolean;
  showVerticalAlign?: boolean;
  showImageCategoryOption?: boolean;

  isVisible: boolean;

  name: string;
  nestedConfigKey?: string;
  childComponents?: RightWidgetConfiguration[] | RightWidgetConfiguration[][];
};
export type FieldAttribute = {
  name: string;
  label: string;
  type: string;
  options: [];
  decision_config: {
    required: string;
  };
  additional_config: unknown;
  css_config: BaseCssConfig;
  slug?: string;
  value?: string | boolean | number;
};

export interface WidgetLayoutAttributes extends UiZoneWidgetAttributeConfig {
  field_attributes: any[];
  label: string;
  show: boolean;
  sub_heading: string;
  timer?: number;
  columns?: Columns[];
  css_config: BaseCssConfig;
  slug?: string;
  title?: string;
  subTitle?: string;
  widgetName?: string;
  widgetIndex?: number;
  isSectionPopup?: boolean;
  isSeparateZone?: boolean;
  widgetProperties: BaseWidgetProperties;
}

export enum ColumnType {
  INPUT = 'input',
  CHECKBOX = 'checkbox',
  DROPDOWN = 'dropdown',
  TEXT = 'text',
}

export type Columns = {
  value: string;
  label: string;
  selected: boolean;
  handleBarKey?: string;
  columnSettings?: {
    columnType: ColumnType;
    dropdownOptions?: any[];
    dropdownOptionLabel?: string;
    dropdownOptionValue?: string;
    inputType?: string; // E.g. text, number
  };
};
export type WidgetLayout = {
  name: string;
  position: number;
  attributes: WidgetLayoutAttributes;
  uniqueId?: number | string;
};

export type WidgetStyleProps = {
  [key: string]: string | undefined;
};

export type Role = {
  id: string;
  name: string;
  userType: string;
  slug: string;
  zones: RoleZones;
  navBar: NavBar;
  applied_all_zones: boolean;
  is_removable: boolean;
  themeOptions: { value: string; isPrimary: boolean }[];
};

export type NavBar = {
  navBarMobile: NavBarMobile;
  navBarDesktop: NavBarDesktop;
};

export type NavBarMobile = {
  iconSize: string;
  navBarColor: string;
  showLabels: boolean;
  labelFontSize?: number;
  layout: NavBarLayoutItem[];
  marginUnit: string;
  marginTop: number;
  marginRight: number;
  marginLeft: number;
  marginBottom: number;
  paddingUnit: string;
  paddingTop: number;
  paddingBottom: number;
  paddingLeft: number;
  paddingRight: number;
  borderRadiusUnit: string;
  borderRadiusTopLeft: number;
  borderRadiusTopRight: number;
  borderRadiusBottomRight: number;
  borderRadiusBottomLeft: number;
  borderWidthUnit: string;
  borderWidth: number;
  borderColor: string;
  useHtml: boolean;
  htmlContent: string;
};

export type NavBarDesktop = {
  logo: string;
  menuType: 'vertical' | 'horizontal';
  iconSize: string;
  userNameColor: string;
  logOutColor: string;
  navBarColor: string;
  activeItemColor: string;
  marginUnit: string;
  marginTop: number;
  marginRight: number;
  marginLeft: number;
  marginBottom: number;
  paddingUnit: string;
  paddingTop: number;
  paddingBottom: number;
  paddingLeft: number;
  paddingRight: number;
  width: number;
  logoType: 'text' | 'icon';
  layout: NavBarLayoutItem[];
  useHtml: boolean;
  htmlContent: string;
};

export type NavBarLayoutItem = {
  title: string;
  order: number;
  navigateToZone: string;
  activeIconColor: string;
  inactiveIconColor: string;
  itemActiveIn: 'page' | 'zone';
  icon: string;
  iconSizeWidth: number;
  iconSizeHeight: number;
  iconSizeUnit: string;
  navigationOption?: NavigationOptionEnum;
  tabRef?: string;
  externalUrl?: string;
  selectedBrowserBehaviour?: string;
};

export type Subscriptions = {
  default: SubscriptionType;
  gold: SubscriptionType;
  silver: SubscriptionType;
  bronze: SubscriptionType;
};

export type SubscriptionType = {
  title: string;
};

export type PermissionSectionsZones = {
  [key: string]: ZoneDetail;
};

export type ZoneDetail = {
  title: string;
  name: string;
  position: number;
  allowedViews: {
    [key: string]: boolean;
  };
  zoneType: ZONETYPEOPTION | undefined;
  entityType?: ENTITY_TYPE;
  is_role_specific: boolean;
  url: string;
  userTypes?: string[];
  packs?: PACKS[];
};

export enum ENTITY_TYPE {
  USER_PREFERENCE = 'user_preference',
  FACILITY = 'facility',
  TRIP = 'trip',
  EVENT = 'event',
  EMPLOYEE = 'employee',
}

export enum ZONETYPEOPTION {
  ENTITYZONEQUESTION = 'entity_zone_questions',
  DEFAULT = 'default',
}

export type RoleZones = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  [key: string]: CanvasZone | null;
};

export type CanvasZone = {
  canvases: Canvases;
};

export type Canvases = {
  name: string;
  subscription: CanvasSubscription;
};

export type DefaultConfig = {
  mobile: WorkflowZoneConfig | UiZoneConfig;
  tablet: WorkflowZoneConfig | UiZoneConfig;
  desktop: WorkflowZoneConfig | UiZoneConfig;
};
export type Default = {
  config: DefaultConfig;
};

export type CanvasSubscription = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  [key: string]: UiZoneDevicesConfig | WorkflowZoneDevicesConfig | null | undefined;
};

export type InputFieldType =
  | 'text'
  | 'number'
  | 'date'
  | 'email'
  | 'phone'
  | 'select'
  | 'checkbox'
  | 'radio'
  | 'group'
  | 'boolean';

export type ProjectFormsConfig = {
  id: string;
  fieldsConfig: {
    id: string;
    type: InputFieldType;
    label: string;
    name: string;
  }[];
  childForms?: ProjectFormsConfig[];
  parentFormID?: string;
  formType?: 'root' | 'group' | 'array';
};

export type PermissionConfig = {
  subscriptions: Subscriptions;
  zones: PermissionSectionsZones;
  roles: Role[];
  projectForms?: ProjectFormsConfig[];
};

export type SystemZones = {
  [key: string]: SystemZoneDetail;
};

// New type to invert the structure to be role -> zones -> canvas -> devices
// Allowing for easier lookup of what a user with a specific role can access
export type SystemAllZonesForRole = {
  [zoneKey: string]: SystemRoleCanvas | null;
};

export type SystemZoneDetail = {
  title: string;
  roles: SystemZoneRoles;
};

export type SystemZoneRoles = {
  [roleKey: string]: SystemRoleCanvas;
};

export type SystemRoleCanvas = {
  [subscriptionKey: string]: SystemDefaultCanvasConfig;
};

export type SystemDefaultCanvasConfig = {
  [key in SupportedDevice]: UiZoneConfig;
};

export type SupportedDevice = 'mobile' | 'desktop' | 'tablet';

// eslint-disable-next-line @typescript-eslint/ban-types
export type SystemAllTheConfigOptions = {};
export type SectionPageConfiguration = {
  page: ComponentLabel;
  position: number;
  page_zone: string;
  page_section: string;
  componentLabel: ComponentLabel;
  isAutoBuild?: boolean;
  slug?: string;
};

export interface ActiveState extends SectionPageConfiguration {
  currentModuleType: PAGELAYOUTTYPE;
  currentSectionItem: number;
  prevZone: string;
  clearScreenContainer: boolean;
}

export const supportedFonts: Array<{ name: string; value: string; type?: 'Google' | 'Custom' }> = [
  {
    name: 'Global Primary Font',
    value: 'var(--font-family)',
  },
  {
    name: 'Global Secondary Font',
    value: 'var(--secondary-font-family)',
  },
  {
    name: 'Mulish',
    value: 'Mulish',
    type: 'Google',
  },
  {
    name: 'Roboto',
    value: 'Roboto',
    type: 'Google',
  },
  {
    name: 'Montserrat',
    value: 'Montserrat',
    type: 'Google',
  },
  {
    name: 'Ubuntu',
    value: 'Ubuntu',
    type: 'Google',
  },
  {
    name: 'Open Sans',
    value: 'Open Sans',
    type: 'Google',
  },
  {
    name: 'Lato',
    value: 'Lato',
    type: 'Google',
  },
  {
    name: 'Prata',
    value: 'Prata',
    type: 'Google',
  },
  {
    name: 'Inter',
    value: 'Inter',
    type: 'Google',
  },
  {
    name: 'Michroma',
    value: 'Michroma',
    type: 'Google',
  },
  {
    name: 'Plus Jakarta Sans',
    value: 'Plus Jakarta Sans',
    type: 'Google',
  },
  {
    name: 'Jost',
    value: 'Jost',
    type: 'Google',
  },
  {
    name: 'PT Sans',
    value: 'PT Sans',
    type: 'Google',
  },
  {
    name: 'Karla',
    value: 'Karla',
    type: 'Google',
  },
  {
    name: 'Poppins',
    value: 'Poppins',
    type: 'Google',
  },
  {
    name: 'CircularStd',
    value: 'CircularStd',
    type: 'Custom',
  },
];

export type PasswordFieldConfigurations = {
  cssConfig?: {
    showPasswordIcon: string;
    hidePasswordIcon: string;
    successIcon: string;
    errorIcon: string;
    successIconVisible: boolean;
    errorIconVisible: boolean;
    showPasswordIconVisible: boolean;
  };
};

export type StyleConfig = {
  name: string;
  fontFamily?: string;
  secondaryFontFamily?: string;
  systemName: string;
  legalEntityName: string;
  loginPageConfig: {
    logoEnabled: boolean;
    passwordFieldConfig?: PasswordFieldConfigurations;
  };
  logo: string;
  logoTitle?: string;
  font_list?: string[];
  alternativeThemes?: {
    [key: string]: AlternativeStyleConfig;
  };
};

export type AlternativeStyleConfig = Omit<StyleConfig, 'colour_palettes' | 'font_list'>;

export type GlobalThemes = {
  globalTheme: GlobalThemeConfiguration;
  cssString: string;
  activeThemeIndex: number;
};

export type GridPosition = {
  x: number;
  y: number;
  cols: number;
  rows: number;
  minItemRows?: number;
  minItemCols?: number;
  resizeEnabled: boolean;
  dragEnabled: boolean;
  layerIndex?: number;
  uniqueId?: string | number;
  name?: string;
};

export interface GridsterLayerEvent {
  layerIndex: number;
  uniqueId: string | number;
  gridPosition: GridPosition;
  index: number;
}

export type Section = {
  uniqueId: number | string;
  isMultiple?: boolean;
  widgetConfiguration: RightWidgetConfiguration;
  pages: SectionPageConfiguration[];
  name: WidgetNames | SectionNames;
  title: string;
  shape: string;
  type: string;
  display: string;
  position: number;
  gridPosition?: GridPosition;
  pageType: string;
  widgetPages?: Section[];
  isSectionPopup?: boolean;
  image?: string;
};

export enum SINK_TYPE {
  HASURA = 'hasura',
  METADATA = 'metadata',
}

export type customDataQuestionDataType = {
  data_type: string; // datetime, string, number, stringArray
  entity: string; // user_preference
  sink: string; // metadata || hasura
  isUpdateToHasura?: boolean;
};

export type QuestionPropertiesOption = {
  text: string;
  value: string;
  suboption?: { text: string; value: string; checked?: boolean }[];
  checked?: boolean;
};

export type questionProperties = {
  name: string;
  label: string;
  type: string;
  options: QuestionPropertiesOption[];
  preSelectSubAnswer: string;
};

export type customDataQuestionType = {
  questionUniqueId: string;
  type: string; // checkbox, dropdown
  header: string;
  subHeader: string;
  questionProperties: questionProperties;
  validationRules: ValidationRules[];
};

export type customDataType = {
  data: {
    [questionUniqueId: string]: customDataQuestionDataType;
  };
  questions: {
    [questionUniqueId: string]: customDataQuestionType;
  };
};

export type WorkflowConfig = {
  projectId?: string;
  version?: string;
  permissionSections: PermissionConfig;
  styleConfig: StyleConfig;
  packs?: string[];
  customData: customDataType;
  alertsConfig?: AlertStyleConfigurationType;
  pageNavigationMap?: PageNavigationMap;
};

export enum ContainerType {
  PAGE = 'page',
  MODAL = 'modal',
}

export type ActiveConfig = {
  activeViewScreen: {
    page: string;
  };
  activeSection: string;
  activeCanvasSubscription: string;
  activeZone: string;
  activeRole: string;
  activeRoleIndex: number;
  activeDevice: SupportedDevice;
  activeUserType: WorkflowUserType;
  // activePageIndex is used to determin page section shown
  activePageIndex: number;

  isFullSectionPage: boolean;
  activeScreenWidth: number;
  activeScreenHeight: number;
  activeTabSelections?: {
    [key: string]: string;
  };
  isAppWindowPreview?: boolean;
  activeContainerType: ContainerType;
  activeCodeEditorTheme?: string;
  activePageTitle?: string;
  activePageName?: string;
  sectionIndex?: number;
  isRemovable?: boolean;
  isActivePage?: boolean;
  isLeftPanelVisible?: boolean;
  isRightPanelVisible?: boolean;
  footerLayoutEnabled?: boolean;
};

export enum WorkflowUserType {
  ORG = 'org',
  USER = 'user',
  SIGNED_OUT = 'signed-out',
}

export enum APP_ZONES {
  TEMPLATE_EDITOR = 'template_editor',
  ONBOARDING = 'onboarding',
  VERIFICATION = 'verification_zone',
  LANDING = 'landing_zone',
  PROFILE = 'profile_zone',
  PAYMENT = 'payments_zone',
  GENERAL = 'general_zone',
  ORGANISATION_ONBOARDING = 'organisation-onboarding',
  ORGANISATION_VERIFICATION = 'organisation_verification',
  ORGANISATION_PROFILE = 'org_profile_zone',
  SIGNED_OUT_FIRST_INTRODUCTION = 'first-intro',
  SIGNED_OUT_INTRODUCTION = 'intro',
  LOGIN = 'login',
  ACCOUNTS_ZONE = 'accounts_zone',
  SIGNED_OUT_FORGOT_PASSWORD = 'forgot_password',
  BENEFICIARY_ZONE = 'beneficiary_zone',
  CARD_MANAGEMENT_ZONE = 'card_management_zone',
}

export enum WORKFLOW_POPUPS {
  IMAGE_WIDGET = 'imageWidgetPopup',
  QUESTION_SUMMARY_WIDGET = 'questionSummaryWidget',
  ORGANISATION_PROFILE = 'workflowManagerOrganisationProfilePopup',
  BENEFICIARY_ZONE = 'workflowManagerBeneficiaryZonePopup',
  CARD_MANAGEMENT_ZONE = 'workflowManagerCardManagementPopup',
  FORM_WIDGET_POPUP = 'formWidgetPopup',
}

export type LineAdditionalConfig = {
  lineThickness: number;
  lineWidth: number;
  paddingBottom: number;
  paddingTop: number;
  paddingLinked: boolean;
  color: string;
  show: boolean;
  showlineWidget: boolean;
  contentAlignment: string;
};

export interface CardManagementAdditionalConfig extends WidgetLayoutAttributes {
  color: string;
  show: boolean;
  contentAlignment: string;
  isSeparateZone: boolean;
}

export type CardManagementPopupOption = {
  type: ComponentLabel;
  index: number;
};

export interface StyleStateEntry {
  css: string;
  selector?: string;
}

export interface StyleState {
  [key: string]: string | StyleStateEntry;
}

export interface BaseCssConfig {
  marginUnit: string;
  marginTop: number;
  marginLeft: number;
  marginRight: number;
  marginBottom: number;
  paddingUnit: string;
  paddingTop: number;
  paddingLeft: number;
  paddingRight: number;
  paddingBottom: number;
  showPadding?: boolean;
  // NOTE: configs stored before the font-size panel coerced its input may
  // still hold numeric strings here; pruneBaseCssConfig normalises them
  fontSize?: number;
  fontUnit?: string;
  color?: string;
  textAlignment?: string;
  borderRadiusUnit?: string;
  borderRadiusTopLeft?: number;
  borderRadiusBottomLeft?: number;
  borderRadiusTopRight?: number;
  borderRadiusBottomRight?: number;
  inputBorderRadiusUnit?: string;
  inputBorderRadiusTopLeft?: number;
  inputBorderRadiusBottomLeft?: number;
  inputBorderRadiusTopRight?: number;
  inputBorderRadiusBottomRight?: number;
  borderWidth?: number;
  borderWidthUnit?: string;
  borderWidthRight?: number;
  borderWidthLeft?: number;
  borderWidthBottom?: number;
  borderWidthTop?: number;
  borderColor?: string;
  borderStyle?: string;
  borderClass?: BorderRadiusClass;
  inputBorderWidth?: number;
  inputBorderColor?: string;
  inputIdleBackgroundColor?: string;
  inputIdleBorderColor?: string;
  inputActiveBackgroundColor?: string;
  fontWeight?: string;
  backGroundColor?: string;
  selectedBorderColor?: string;
  verticalAlignment?: string;
  disabledTextColor?: string;
  disabledBgColor?: string;
  selectedobjectfit?: string;
  selectedOpacity: number;
  isTextBold: boolean;
  isiTextItalic: boolean;
  isTextUnderline: boolean;
  textFont?: string;
  shadowBlur: number;
  shadowSpread: number;
  shadowOffsetX: number;
  shadowOffsetY: number;
  shadowColor: string;
  noAlignment?: boolean;
  inputPlaceholderColor?: string;
  inputCustomStyling?: string;
  textInputFontSize?: number; // legacy stored strings normalised like fontSize
  textInputFontUnit?: string;
  textInputBackgroundColor?: string;
  iconUnit?: string;
  iconSize?: number;
  iconColor?: string;
  leftIconColor?: string;
  leftIconUnit?: string;
  rightIconUnit?: string;
  righticonSize?: number;
  rightIconColor?: string;
  lefticonSize?: number;
  width?: number;
  height?: number;
  dimensionUnit?: string;
  alertColor?: string;
  backgroundGradient?: string;
  widthDimensionUnit?: string;
  heightDimensionUnit?: string;
  activeBackgroundColor?: string;
  inactiveBackgroundColor?: string;
  inactiveBorderColor?: string;
  activeBorderColor?: string;
  elementStyling?: {
    [key: string]: StyleState;
  };
}

export type NotificationSettingsWidgetLevel = {
  channel: string;
  isActive: boolean;
  category: string;
};

export type InputFieldSettings = {
  showFlags?: boolean;
  isIconAllowed?: boolean;
  sellAccountLabel?: string;
  buyAccountLabel?: string;
  amountInputLabel?: string;
  currencyLabel?: string;
  countryLabel?: string;
  companyNameLabel?: string;
  isAllowed?: boolean;
  label?: string;
  css_config: InputCssConfig;
  isTimerSeparated?: boolean;
};

export type InputCssConfig = {
  inactiveBorderColor?: string;
  activeBorderColor?: string;
  backgroundColor?: string;
  inactiveBackgroundColor?: string;
  activeBackgroundColor?: string;
  borderRadiusTopLeft?: number;
  borderRadiusTopRight?: number;
  borderRadiusBottomLeft?: number;
  borderRadiusBottomRight?: number;
  borderWidth?: number;
  borderColor?: string;
  borderStyleUnit?: string;
  inputHeight?: number | undefined;
  inputWidth?: number;
  iconSize?: number;
  iconSizeUnit?: string;
  inputTextColor?: string;
  inputPosition?: string;
};

export type AllowedCurrencyType = {
  code: string;
  name: string;
};

export type AllowedCountryType = {
  key: string;
  currencyFlag: string;
  title: string;
};

export type BaseWidgetProperties = {
  textContent: string;
  paymentGateway?: PaymentProvider;
  icon?: string;
  headerColor?: string;
  subheaderColor?: string;
  preSelectSubAnswer?: string;
  [key: string]: any;
  dateType?: DatePickerTypes;
  animationSource?: string;
  assetType?: string;
  assetUrl?: string;
  animationType?: string;
  animationFileName?: string;
  uploadFileId?: string;
  righticon?: string;
  lefticon?: string;
  notificationSettings?: NotificationSettingsWidgetLevel;
  inputFieldSettings?: InputFieldSettings;
  allowedCurrencies?: AllowedCurrencyType[];
  allowedCountries?: AllowedCountryType[];
  selectedDefaultCurrency?: string;
  context?: 'Buy' | 'Sell';
  showFlag?: boolean;
  widgetContext?: any;
  buttonActionType?: ButtonActionType; // for defining action of CTA button Widget
  actionScript?: string;
  documentActionType?: DocumentActionType;
  headerConfig?: {
    headerFontSize?: number;
    headerFontUnit?: string;
    headerTextFont?: string;
    headerColor?: string;
  };
  subHeaderConfig?: {
    subHeaderFontSize?: number;
    subHeaderFontUnit?: string;
    subHeaderTextFont?: string;
    subheaderColor?: string;
  };
  textStyleClass?: string;
  inputLabel?: string;
  actionNavigationConfigurations?: actionButtonNavigationConfigType;
  delayButtonActivation?: boolean;
  activationDelaySeconds?: number;
  skeletonPreviewData?: any;
  skeletonConfigTableData?: any;
  formsConfig?: FormsConfigType;
  inputFieldConfig?: FormFieldConfig;
  loadingTextContent?: string;
  itemsPerRow?: number;
  gestures?: Gestures;
  productFilterConfig?: ProductFilters;
};

export type ProductFilters = {
  journeyType: ProductFilterJourneyType;
  customerType: ProductFilterCustomerType;
  accountType: ProductFilterAccountType;
};

export enum ProductFilterJourneyType {
  NEW_SAVINGS_PRODUCT = 'new-savings-product',
  RENEWAL_SAVINGS_PRODUCT = 'renewal-savings-product',
}

export enum ProductFilterCustomerType {
  RETAIL = 'retail',
  BUSINESS = 'business',
}

export enum ProductFilterAccountType {
  ALL = 'all',
  FIXED_TERM = 'fixed-term',
  EASY_ACCESS = 'easy-access',
  NOTICE = 'notice',
}

export interface Gestures {
  swipeEnabled?: boolean;
  dragEnabled?: boolean;
  panEnabled?: boolean;
}

export enum DatePickerTypes {
  DATEPICKER = 'datepicker',
  INPUT = 'input',
}
export enum ValidationRuleTypes {
  REQUIRED = 'required',
  PATTERN = 'pattern',
  MINLENGTH = 'minlength',
  MAXLENGTH = 'maxlength',
  EMAIL = 'email',
  MINVALUE = 'min',
  MAXVALUE = 'max',
}

export type ValidationRules = {
  // isRequired: boolean | undefined;
  type: ValidationRuleTypes;
  value: string;
};

export type baseCssConfigStyle = {
  'margin-top'?: string;
  'margin-left'?: string;
  'margin-right'?: string;
  'margin-bottom'?: string;
  'padding-top'?: string;
  'padding-left'?: string;
  'padding-right'?: string;
  'padding-bottom'?: string;
  'font-size'?: string;
  color?: string;
  'text-align'?: string;
  'border-top-left-radius'?: string;
  'border-top-right-radius'?: string;
  'border-bottom-right-radius'?: string;
  'border-bottom-left-radius'?: string;
  'border-width'?: string;
  'border-color'?: string;
  'border-style'?: string;

  'font-weight'?: string;
  'background-color'?: string;
  border?: string;
  height?: string;
  width?: string;
  display?: string;
  'align-items'?: string;
  'justify-content'?: string;
  position?: string;
  'background-size'?: string;
  'object-fit'?: string;
  bottom?: string;
  top?: string;
  left?: string;
  right?: string;
  background?: string;
  'box-shadow'?: string;
};

export enum TextAlignToJustifyContent {
  left = 'start',
  center = 'center',
  right = 'end',
}

export type LineAdditionalConfigStyle = {
  line: {
    'border-bottom': string;
    width: string;
  };
  content: {
    'padding-bottom': string;
    'padding-top': string;
    'justify-content': string;
    visibility: string;
  };
};

export interface TextAdditionalConfig extends UiZoneWidgetAttributeConfig {
  color: string;
  show: boolean;
  widgetProperties: BaseWidgetProperties;
}

export interface TextItemWidgetConfig extends UiZoneWidgetAttributeConfig {
  color: string;
  showTextItemWidget: boolean;
  title: string;
  subTitle: string;
  showQuickLinksWidget?: boolean;
  url?: string;
  btnFnName?: string;
  isButton?: boolean;
  widgetProperties: BaseWidgetProperties;
}

export interface QuickLinksWidgetConfig extends UiZoneWidgetAttributeConfig {
  zone: string;
  pageUrl: string;
  pageId: string;
  title: string;
  role: string;
  widgetProperties: BaseWidgetProperties;
}

export interface SwitchNavigatorQuickLinkWidgetConfig extends UiZoneWidgetAttributeConfig {
  linksList: {
    textContent: string;
    pageUrl: string;
    pageId: string;
    zone: string;
  }[];
  role: string;
  widgetProperties: BaseWidgetProperties;
}

export interface LogoutWidgetConfig extends UiZoneWidgetAttributeConfig {
  title: string;
  widgetProperties: BaseWidgetProperties;
}

export interface NotificationWidgetConfig extends UiZoneWidgetAttributeConfig {
  widgetProperties: BaseWidgetProperties;
}

export interface AddCurrencyAccountWidgetConfig extends UiZoneWidgetAttributeConfig {
  widgetProperties: BaseWidgetProperties;
}

export interface H1AdditionalConfig extends UiZoneWidgetAttributeConfig {
  color: string;
  show: boolean;
  widgetProperties: BaseWidgetProperties;
}

export interface IFrameAdditionalConfig extends UiZoneWidgetAttributeConfig {
  iframeUrl: string;
  verticalHeight: string;
  showIFrameWidget: boolean;
}

export interface IFrameAdditionalConfigStyle {
  content: {
    height: string;
  };
  baseConfig: baseCssConfigStyle;
}

export interface NavBarIconStyle {
  width: string;
  height: string;
}

export interface ExchangeCurrencyAdditionalConfig {
  contextPage: string;
  showFlag: boolean;
  sellAccountLabel: string;
  buyAccountLabel: string;
  amountLabel: string;
}

export interface CardsWidgetConfig extends UiZoneWidgetAttributeConfig {
  doesContextSwitch: boolean;
  cardLayoutType: 'listing' | 'carousel' | 'individual';
  widgetProperties: BaseWidgetProperties;
}

export enum APP_ZONES_TITLE {
  ONBOARDING_PAGE = 'Onboarding',
  LANDING = 'Landing',
  PAYMENT = 'Payments',
  PROFILE = 'Profile',
  VERIFICATION = 'Verification',
  GENERAL = 'General',
  ORGANISATION_ONBOARDING = 'Onboarding Organisation',
  ORGANISATION_VERIFICATION = 'Verification Organisation',
  ORGANISATION_PROFILE = 'Business Profile',
  SIGNED_OUT_FIRST_INTRODUCTION = 'First Time Intro',
  SIGNED_OUT_FORGOT_PASSWORD = 'Forgot Password',
  SIGNED_OUT_INTRODUCTION = 'Introduction',
  ACCOUNTS_ZONE = 'Accounts',
  BENEFICIARY_ZONE = 'Beneficiary',
  CARD_MANAGEMENT_ZONE = 'Card Management',
}

export type AppGridCanvasBody = {
  index: number;
  value: Role;
  tableEntries: Array<{
    key: string;
    value: CanvasZone | null;
    position: number;
    allowedViews: {
      [key: string]: boolean;
    };
  }>;
};

export type AllowedViews = {
  [key: string]: boolean;
};

export enum DELIVERY_STATUS {
  Ordered = 'Ordered',
  Dispatched = 'Dispatched',
  Shipped = 'Shipped',
  Delivered = 'Delivered',
  InProgress = 'In Progress',
}

export enum WidgetTitles {
  SIGNUP = 'Signup',
  VERIFICATION = 'Verification',
  CARD_MANAGEMENT_ZONE = 'Card Management Zone',
  FREEZE_CARD = 'Freeze Card',
  VIEW_CARD_DELIVERY_STATUS = 'Card Delivery Status',
  RECENT_TRANSACTION_LIST_WIDGET = 'Transaction History',
  AUTO_BUILD_FORM = 'Auto Build Form',
  LINE_WIDGET = 'Line Widget',
  TEXT_WIDGET = 'Text',
  IFRAME_WIDGET = 'IFrame Widget',
  PROFILE_DETAILS = 'Profile Details',
  LANDING = 'Landing',
  QUICK_LINKS_WIDGET = 'Quick Links',
  RESEND_WIDGET = 'Resend Links',
  IMAGE_WIDGET = 'Image',
  GENERIC_CAROUSEL_WIDGET = 'Carousel',
  SUMSUB_Title = 'Sumsub Section',
  AIRWALLEX_RFI_WIDGET = 'Airwallex RFI',
  AIRWALLEX_KYC_WIDGET = 'Airwallex Onboarding',
  ADDRESS_WIDGET = 'Address',
  MULTI_ROLE = 'Multi Organisation',
  BACK_BUTTON_WIDGET = 'Back Navigation Button',
  FORWARD_BUTTON_WIDGET = 'Forward Navigation Button',
  ADD_BENEFICIARY_WIDGET = 'Add Beneficiary Widget',
  PASSWORD_CHANGE_WIDGET = 'Change Password',
  PASSWORD_FORGOT_WIDGET = 'Forgot Password',
  ENTER_EMAIL_WIDGET = 'Enter Email',
  INTL_BENEFICIARY_ADDRESS_WIDGET = 'Intl Beneficiary Address',
  INTL_BENEFICIARY_ADDED_WIDGET = 'Intl Beneficiary Added',
  LOGOUT = 'Logout',
  SWITCH_NAVIGATOR_QUICK_LINK = 'Switch Navigator Quick Link',
  BENEFICIARY_SELECTION_WIDGET = 'Beneficiaries',
  MULTI_ICON_QUICK_LINK_WIDGET = 'Multi Icon Quicklink',
  LOTTIE_ANIMATION = 'Lottie Animation',
  CURRENCY_INPUT_FIELD_WIDGET = 'Currency Input Field Widget',
  PAYMENT_REF_WIDGET = 'Payment Reference Widget',
  MANDATORY_CTA_BUTTON = 'Action Button Widget',
  PROFILE_PICTURE_WIDGET = 'Profile Picture',
  NOTIFICATION_BELL_WIDGET = 'Notification Bell',
  BIOMETRICS_AUTHENTICATION_WIDGET = 'Authentication',
  NOTIFICATION_LIST_WIDGET = 'Notification List',
  NOTIFICATION_WIDGET = 'Notification',
  CURRENCY_ACCOUNTS_LISTING_WIDGET = 'Accounts Listing',
  EXCHANGE_CURRENCY_WIDGET = 'Exchange Currency',
  ADD_CURRENCY_ACCOUNT_WIDGET = 'Add Currency Account',
  EXCHANGE_QUOTE_WIDGET = 'Exchange Quote',
  EXCHANGE_QUOTE_SUMMARY = 'Exchange Summary',
  FILE_UPLOAD_WIDGET = 'File Upload',
  INTERNATIONAL_CURRENCY_COUNTRY = 'Intl. Currency & Country',
  INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET = 'International Beneficiary Credentials Widget',
  VERIFICATION_ORGANISATION_COMPANY_NAME = 'Company Name Widget',
  RANGE_CALENDAR_WIDGET = 'Range Calendar',
  OTP_VERIFICATION = 'OTP Verification',
  LANDING_ACCOUNTS_LISTING = 'Currency Accounts',
  ACCOUNTS_CONTEXT_DROPDOWN = 'Account Context Drop-down',
  PAYMENT_REASON = 'Payment Reason Widget',
  EDIT_BENEFICIARY_WIDGET = 'Edit Beneficiary Widget',
  DESKTOP_BULK_PAYMENT_LISTING_WIDGET = 'Bulk Payment Listing',
  DESKTOP_BULK_PAYMENT_HISTORY_LISTING_WIDGET = 'Desktop Bulk Payment History Listing',
  ONBOARDING_BACK_NEXT_BUTTON = 'Back Next Button',
  CONDITIONAL_WIDGET = 'Conditional Widget',
  UPLOAD_FILE_WITH_POPUP_WIDGET = 'Upload File With Popup Widget',
  SECTION = 'Section',
  MULTI_COLUMN = 'Multi-column',
  TAB = 'Tab',
  SPACER = 'Spacer',
  COPY_SHARE_CONTENT = 'Copy/Share Content',
  CARDS_WIDGET = 'Cards Widget',

  CARD_SENSITIVE_DETAILS = 'Card Sensitive Details',
  DESKTOP_PAYMENT_REQUEST_PENDING_APPROVED_LISTING_WIDGET = 'Payment Request Widget',
  SECONDARY_IDENTIFIER = 'Secondary Identifier',
  CARD_PIN = 'Card PIN Widget',
  ADD_TO_GOOGLE_PAY_BUTTON = 'Add to Google Pay',
  ADD_TO_APPLE_WALLET_BUTTON = 'Add to Apple Wallet',
  PAYMENT_RAIL_SELECTOR_WIDGET = 'Payment Rail Selector Widget',
  ADD_BENEFICIARY_INTL_WIDGET = 'Add Beneficiary Intl.',
  VERIFICATION_ORG_EDIT_INCORPORATION_DATE = 'Incorporation Date',
  EDIT_BENEFICIARY_INTL_WIDGET = 'Edit Beneficiary Intl.',
  THEME_SELECTOR = 'Theme Selector',
  CURRENCY_SELECTOR_WIDGET = 'Currency Selector',
  FORM_WIDGET = 'Form',
  INPUT_WIDGET = 'Input',
  FORM_BUTTON_WIDGET = 'Form Button',
  DISPLAY_DOCUMENT_WIDGET = 'Display Document',
  BENEFICIARY_TYPE_WIDGET = 'Beneficiary Type',
  ACCORDION_WIDGET = 'Accordion Widget',
  BENEFICIARY_COUNTRY_CURRENCY_WIDGET = 'Beneficiary Country and Currency',
  BENEFICIARY_PAYMENT_RAIL_WIDGET = 'Beneficiary Payment Rail',
  BENEFICIARY_CREDENTIALS_WIDGET = 'Beneficiary Credentials',
  BENEFICIARY_ADDRESS_WIDGET = 'Beneficiary Address',
  CHART_WIDGET = 'Chart',
  BANK_LISTING_WIDGET = 'Bank Listing',
  PISP_BANK_LIST_WIDGET = 'PISP Bank List',
  PISP_CHECK_BILLING_REQUEST_LOADER_WIDGET = 'PISP Check Billing Request Loader',
  GOCARDLESS_COMPLIANCE_WIDGET = 'GoCardless PISP Compliance',
  NAME_WIDGET = 'Name',
  BIRTHDAY_WIDGET = 'Birthday',
  ACCOUNT_SELECTION_WIDGET = 'Account Selection',
  PASSWORD_WIDGET = ' Password',
  DOCUMENT_LISTING_WIDGET = 'Document Listing',
  MULTI_CURRENCY_WIDGET = 'Multi-Currency Currency Selector',
  PAYMENT_CANCELLATION_WIDGET = 'Payment Cancellation',
  CANCEL_PAYMENTS_INFO_WIDGET = 'Cancelable Payments Info',
  CLOUDFLARE_TURNSTILE_WIDGET = 'Cloudflare Turnstile',
  SUPPORT_CHAT_LIST_WIDGET = 'Support Chat List',
  SUPPORT_CHAT_WIDGET = 'Support Chat',
  PRODUCTS_LISTING_WIDGET = 'Products List',
  FORM_ADDRESS_HISTORY_WIDGET = 'Address History Widget',
  TOOLTIP_WIDGET = 'Tooltip Widget',
  COMPANIES_HOUSE_SEARCH_WIDGET = 'Companies House Search',
  COMPANIES_HOUSE_LISTING_WIDGET = 'Companies House Listing',
  COMPANIES_HOUSE_DIRECTOR_SELECTION_WIDGET = 'Companies House Director Selection',
  AUTHENTICATION_FLOW_WIDGET = 'Authentication Flow',
  VARIABLE_RECURRING_PAYMENT_LIST_WIDGET = 'Variable Recurring Payment List',
  CUSTOM_WIDGET = 'Custom Widget',
}

export enum NavigationOptionEnum {
  USE_AS_BLANK = 'use-as-blank',
  USE_AS_NAVIGATION = 'use-as-navigation',
  USE_AS_NAVIGATION_WITH_ACTIVE_TAB = 'use-as-navigation-with-active-tab',
  USE_AS_EXTERNAL_LINK = 'use-external-link',
  USE_AS_MODAL = 'use-as-modal',
}

export enum ConditionEnum {
  LESS_THAN = '<',
  GREATER_THAN = '>',
  EQUAL = '===',
  LESS_THAN_EQUAL = '<=',
  GREATER_THAN_EQUAL = '>=',
  NOT_EQUAL = '!==',
}

export enum ConditionalWidgetVariableEnum {
  KYC_PERSONAL = 'kyc_personal',
  BUSINESS_ONBOARDING = 'business_onboarding',
  KYB_BUSINESS = 'kyb_business',
  USER_LOGGED_IN = 'user_logged_in',
}

export type HandlebarHelperContext = {
  helperVariable: string;
  contextValue: string;
};
